import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { videos } from 'src/constants/videos'
import styled from 'styled-components'

export default (props) => {
  return (
    <StyledContainer>
      <CanadaTemplateDefault
        location={props.location}
        lang="en"
        market="canada"
        hasOfferInput={true}
        offerBanner={{
          title: ['Enter your Marc & Mandy Show promo code', 'to redeem 6 months of Fubo for FREE'],
        }}
        ctaText="Redeem offer"
        video={videos.seasonal_ca.videoUrl}
        videoMobile={videos.seasonal_ca.videoMobileUrl}
        annotations={videos.seasonal_ca.annotations}
        title="Watch live sports & entertainment"
        subtitle="Enjoy top leagues, popular TV shows & more"
        // networkSet="canadaEssentials"
        hasPlanCardsTabs={false}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 800px;
  }
`
